import {FC} from "react";
import {Outlet} from "react-router-dom";
import "./FullPageLayout.scss";

export const FullPageLayout: FC = () => (
  <div className="FullPageLayout">
    <div className="FullPageLayout-body">
      <Outlet />
    </div>
  </div>
);
